import { RevisionSystemConfig } from '../../revision-system/config/RevisionSystemConfig';

/**
 * Configuration for the Greek Revision System
 * 
 * This configuration object customizes the shared revision system core
 * for Greek vocabulary learning with the following settings:
 * - Collections: greek-sections, greek-cards, greek-reviews
 * - Routing: /greek-revision/*
 * - Migration: Include only sections starting with "Greek "
 * - UI: Include Greek Input component for entering Greek characters
 */
export const greekConfig: RevisionSystemConfig = {
  collections: {
    sections: 'greek-sections',
    cards: 'greek-cards',
    reviews: 'greek-reviews'
  },
  
  routing: {
    basePath: '/greek-revision'
  },
  
  migration: {
    legacyCollection: 'sections',
    sectionNameFilter: (name: string) => name.startsWith('Greek ')
  },
  
  ui: {
    includeGreekInput: true,
    systemName: 'Greek Revision'
  }
};
